<template>
  <div>
    <div>
      <a-dropdown :trigger="['hover']" placement="bottomCenter">
        <div>
          <a-space size="small"><a-icon type="setting" /></a-space>
        </div>
        <a-menu slot="overlay" class="menu-list">
          <a-menu-item>
          <div id="text-w" @click="suggestShow=true">意见反馈</div>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>

     <a-modal
      title="请输入您的宝贵建议！"
      :visible="suggestShow"
      @ok="submitSuggest"
      @cancel="handleCancel"
    >
        <a-textarea placeholder="您的宝贵建议，是我们前进的动力！" :rows="4"  v-model="content"/>

    </a-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      suggestShow:false,
      content:''
    };
  },
  methods:{
    handleCancel(){
      this.suggestShow = false;
    },

    submitSuggest(){
      let param = {
        receiveId:-1,
        sendId:this.$store.state.user.id,
        senderName:this.$store.state.user.name,
        topic:'SYSTEM_ADMIN',
        tag:'suggest',
        content:this.content,
        broadcast:false,
        title:"意见反馈"
      }
      this.$req.post('/api/message/create',param,(res)=>{
        this.$message.success("反馈成功！我们会尽快给您答复！");
         this.suggestShow = false;
      })
    }
  }
};
</script>
